import React, { useState } from 'react';
import './RoomSelector.css';
import { getRoomName, getRooms } from './RoomConfig';

const RoomSelector = ({ onRoomChange, currentRoom }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleRoomSelect = (room) => {
    onRoomChange(room);
    setIsOpen(false);
  };

  const rooms = getRooms();

  return (
    <div className="room-selector">
      <button 
        onClick={toggleMenu} 
        className="room-selector-button"
      >
        {getRoomName(currentRoom)} {isOpen ? "▲" : "▼"}
      </button>
      
      {isOpen && (
        <div className="room-selector-popup">
          {rooms.map(room => (
            <button
              key={room.id}
              onClick={() => handleRoomSelect(room.id)}
              className={`room-option ${currentRoom === room.id ? 'current' : ''}`}
            >
              {room.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RoomSelector;